import { render, staticRenderFns } from "./investor-update-banner.vue?vue&type=template&id=5c4524cc&"
import script from "./investor-update-banner.vue?vue&type=script&lang=ts&"
export * from "./investor-update-banner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports